import React, { useState } from 'react'
import '../Style/main.css'
import illustrateImage from '../Images/Illustrator.svg'
import bg1 from '../Images/bg1.png'
import bg2 from '../Images/bg2.png'
import { MdNavigateNext, MdNavigateBefore } from 'react-icons/md'
import 'react-toastify/dist/ReactToastify.css'
import { updateEntries } from '../Http/ApiCalls'
import { useLocation, useNavigate } from 'react-router-dom'
import { toast, ToastContainer } from 'react-toastify'
import logo from '../Images/logo.png'
import { useTranslation } from 'react-i18next'

const Form = () => {
    const { t } = useTranslation()
    const location = useLocation()
    const navigate = useNavigate()
    const [currentStep, setCurrentStep] = useState(1)
    const [answers, setAnswers] = useState({})

    if (!location.state) {
        return (window.location.href = '/')
    }
    const userData = location.state.userData

    const questions = [
        {
            id: 1,
            text: t('questionOne'),
            type: 'radio',
            options: [
                { value: 'Yes', label: t('q1op1') },
                { value: 'No', label: t('q1op2') }
            ]
        },
        {
            id: 2,
            text: t('questionTwo'),
            type: 'radio',
            options: [
                { value: 'Reel/Video', label: t('q2op1') },
                { value: 'Image Post', label: t('q2op2') },
                { value: 'Story', label: t('q2op3') }
            ]
        },
        {
            id: 3,
            text: t('questionThree'),
            type: 'checkbox',
            options: [
                { value: 'No Contact With Brand', label: t('q3op1') },
                { value: 'Undefined Processes', label: t('q3op2') },
                { value: "Don't Know How To Do It", label: t('q3op3') },
                { value: 'Trust Issues ', label: t('q3op4') }
            ]
        },
        {
            id: 4,
            text: t('questionFour'),
            type: 'checkbox',
            options: [
                {
                    value: 'Incomplete Campaign Brief',
                    label: t('q4op1')
                },
                { value: 'Lack Of Support', label: t('q4op2') },
                {
                    value: 'Unreasonable Time Constraints',
                    label: t('q4op3')
                },
                { value: 'Payment Issues', label: t('q4op4') }
            ]
        }
    ]

    const handleOptionChange = (questionId, optionValue) => {
        setAnswers({ ...answers, [questionId]: optionValue })
    }

    const handleNext = () => {
        if (!answers[currentQuestion.id] || (Array.isArray(answers[currentQuestion.id]) && answers[currentQuestion.id].length === 0)) {
            toast('Please select an answer before continuing', {
                position: 'top-right',
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                type: 'error'
            })

            return
        }
        updateEntries(userData.id, answers)
        if (currentStep === questions.length) {
            navigate('/submit', {
                state: {
                    userData
                }
            })
        }

        setCurrentStep(currentStep + 1)
    }

    const handlePrev = () => {
        setCurrentStep(currentStep - 1)
    }
    const currentQuestion = questions.find((q) => q.id === currentStep)

    return (
        <div className="surveyForm container-fluid">
            <div className="row">
                <div className="col-5 col-lg-5 col-12">
                    <div className="leftSide">
                        <img
                            src={logo}
                            alt="bglogo"
                            id="logo"
                            className="img-fluid"
                        />
                        <img
                            src={bg2}
                            alt="background"
                            id="bgImage2"
                            className="img-fluid"
                        />
                        <img
                            src={illustrateImage}
                            alt="Illustateimage"
                            id="mainImage"
                            className="img-fluid"
                        />
                        <img
                            src={bg1}
                            alt=""
                            id="bgImage1"
                            className="img-fluid"
                        />
                    </div>
                </div>
                <div className="col-12 col-lg-7">
                    <div className="rightSide">
                        <div>
                            <p>{currentQuestion.text}</p>
                            {(currentStep === 3 || currentStep === 4) && <span style={{ color: '#808080' }}>({t('selectMultiple')})</span>}

                            <div className="options">
                                {currentQuestion.options.map((option) => (
                                    <div key={option.value}>
                                        {currentQuestion.type === 'radio' ? (
                                            <label className={answers[currentQuestion.id]?.includes(option.value) ? 'selected' : ''}>
                                                <input
                                                    type="radio"
                                                    name={currentQuestion.id}
                                                    value={option.value}
                                                    checked={answers[currentQuestion.id] === option.value}
                                                    onChange={() => handleOptionChange(currentQuestion.id, option.value)}
                                                />
                                                {option.label}
                                            </label>
                                        ) : (
                                            <label className={answers[currentQuestion.id]?.includes(option.value) ? 'selected' : ''}>
                                                <input
                                                    type="checkbox"
                                                    name={currentQuestion.id}
                                                    value={option.value}
                                                    checked={answers[currentQuestion.id]?.includes(option.value)}
                                                    onChange={(e) => {
                                                        const checked = e.target.checked
                                                        const values = answers[currentQuestion.id] || []
                                                        const newValues = checked
                                                            ? [...values, option.value]
                                                            : values.filter((v) => v !== option.value)
                                                        handleOptionChange(currentQuestion.id, newValues)
                                                    }}
                                                />
                                                {option.label}
                                            </label>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="paging">
                            {currentStep > 1 && (
                                <button onClick={handlePrev}>
                                    <MdNavigateBefore />
                                </button>
                            )}

                            {currentStep === 1 && (
                                <button
                                    style={{ visibility: 'hidden' }}
                                    onClick={handlePrev}>
                                    <MdNavigateBefore />
                                </button>
                            )}

                            <span>
                                {'0'}
                                {currentStep} / 05
                            </span>

                            <button onClick={handleNext}>
                                <MdNavigateNext />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </div>
    )
}

export default Form
